<template>
  <div>
    <ClientModal
      v-if="editingText"
      @close-modal="editingText=null"
    >
      <template #header>
        <div class="font-bold mb-4">Редактирование надписи</div>
      </template>

      <edit-text
        :editingText="editingText"
        @text-success-saved="editingText=null"
      />
    </ClientModal>
    <div
      class="element-engraving-setting"
      :class="{'open': show}"
      v-if="item"
    >

      <div class="panel">
        <div class="panel__section">
          <div v-if="item.isText">
            <button
              class="btn-text-edit"
              @click="editingText=item"
            >
              <img
                src="/images/icons/engraving-text/redaktirovat.svg"
                alt=""
              >
              <span>Редактировать</span>
            </button>

          </div>

          <div class="panel__title">{{$t('client.engraving.title_position')}}</div>
          <div class="panel__content">
            <div class="panel__form">
              <div class="panel__form_group">
                <div class="panel__label">
                  <img
                    src="/images/design/gravirovka/otstup-verh.svg"
                    alt=""
                  >
                  <span v-html="$t('client.engraving.offset_top')"></span>
                </div>
                <div class="panel__field">
                  <input
                    type="number"
                    @change="e=>changeOffset(e, 'y')"
                    :value="item.offsetTop"
                  >
                </div>
              </div>
              <div class="panel__form_group">
                <div class="panel__label">
                  <img
                    src="/images/design/gravirovka/otstup-levo.svg"
                    alt=""
                  >
                  <span v-html="$t('client.engraving.offset_left')"></span>
                </div>
                <div class="panel__field">
                  <input
                    type="number"
                    @change="e=>changeOffset(e, 'x')"
                    :value="item.offsetLeft"
                  >
                </div>
              </div>
              <div class="panel__form_group">
                <div class="panel__label">
                  <img
                    src="/images/design/gravirovka/ugol-povorota.svg"
                    alt=""
                  >
                  <span v-html="$t('client.engraving.angle')"></span>
                </div>
                <div class="panel__field">
                  <input
                    ref="elementAngle"
                    type="number"
                    min="-180"
                    max="180"
                    @change="changeAngle"
                    :value="item.angle"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="panel__section"
          v-if="!item.isText"
        >
          <div class="panel__title">{{$t('client.engraving.sizes')}}</div>
          <div class="panel__content">
            <div
              class="panel__form"
              v-if="item.type_calc_cost=='fix'"
            >
              <div class="panel__form_group">
                <div class="panel__label">
                  <img
                    src="/images/design/gravirovka/razmery-vybor.svg"
                    alt=""
                  >
                  <span v-html="$t('client.engraving.visota_i_shirina')"></span>
                </div>
                <div class="panel__field">
                  <select @change="selectSize">
                    <option
                      v-for="size in item.sizes"
                      :key="`choose-size-${size.element_size_id}`"
                      :value="size.element_size_id"
                      :selected="item.sizeId==size.element_size_id"
                    >{{size.height}} x {{size.width}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div
              class="panel__form cub"
              v-if="item.type_calc_cost=='cub'"
            >
              <div class="panel__form_group panel__form_group--proporcion">
                <div class="fields_size">
                  <div class="panel__form_group">
                    <div class="panel__label">
                      <img
                        src="/images/design/gravirovka/razmer-vysota.svg"
                        alt=""
                      >
                      <span v-html="$t('client.engraving.height')"></span>
                    </div>
                    <div class="panel__field">
                      <input
                        type="number"
                        :value="item.height"
                        @change="event=>changeSize(event, 'height')"
                      >
                    </div>
                  </div>
                  <div class="panel__form_group">
                    <div class="panel__label">
                      <img
                        src="/images/design/gravirovka/razmer-shirina.svg"
                        alt=""
                      >
                      <span v-html="$t('client.engraving.width')"></span>
                    </div>
                    <div class="panel__field">
                      <input
                        type="number"
                        :value="item.width"
                        @change="event=>changeSize(event, 'width')"
                      >
                    </div>
                  </div>
                </div>
                <div class="sizes__proporcion">
                  <PopupTitle :titleText="$t('client.engraving.proporcion')">
                    <button
                      class="operation__button operation__button--proporcion"
                      :class="{'active': item.proporcion}"
                      @click.prevent="setProporcion"
                    ><img src="/images/design/gravirovka/scepka.svg"></button>
                  </PopupTitle>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel__section">
          <div class="panel__title">{{$t('client.engraving.operation')}}</div>
          <div class="panel__content">
            <div class="panel__operations">
              <div
                class="operation"
                v-if="!item.isText"
              >
                <div class="operation__title">
                  {{$t('client.engraving.operation_mirror')}}
                </div>
                <div class="operation__actions">
                  <div class="operation__action">
                    <PopupTitle :titleText="$t('client.engraving.mirror_gorizontal')">
                      <button
                        class="operation__button"
                        :class="{'active': item.mirrored}"
                        @click.prevent="mirror"
                      ><img src="/images/design/gravirovka/otrazhenie.svg"></button>
                    </PopupTitle>
                  </div>
                </div>
              </div>
              <div class="operation">
                <div class="operation__title">{{$t('client.engraving.operation_layer')}}</div>
                <div class="operation__actions">
                  <div class="operation__action">
                    <PopupTitle :titleText="$t('client.engraving.layer_down')">
                      <button
                        class="operation__button"
                        @click="decrLayer"
                      ><img src="/images/design/gravirovka/sloy-niz.svg"></button>
                    </PopupTitle>

                  </div>
                  <div class="operation__action">
                    <PopupTitle :titleText="$t('client.engraving.layer_up')">
                      <button
                        class="operation__button"
                        @click="incLayer"
                      ><img src="/images/design/gravirovka/sloy-verh.svg"></button>
                    </PopupTitle>
                  </div>
                </div>
              </div>
              <div
                class="operation operation--alignment"
                v-if="!item.isText"
              >
                <div class="operation__title">{{$t('client.engraving.operation_alignment')}}</div>
                <div class="operation__actions">
                  <div class="alignment__horizontal">
                    <div class="operation__action">
                      <PopupTitle :titleText="$t('client.engraving.align_left')">
                        <button
                          class="operation__button"
                          :class="{'active': horizontalAlignmentLeft}"
                          @click="setHorizontalAlignment('left')"
                        ><img src="/images/design/gravirovka/vyravnivanie-levo.svg"></button>
                      </PopupTitle>

                    </div>
                    <div class="operation__action">
                      <PopupTitle :titleText="$t('client.engraving.align_center')">
                        <button
                          class="operation__button"
                          :class="{'active': horizontalAlignmentCenter}"
                          @click="setHorizontalAlignment('center')"
                        ><img src="/images/design/gravirovka/vyravnivanie-centr.svg"></button>
                      </PopupTitle>

                    </div>
                    <div class="operation__action">
                      <PopupTitle :titleText="$t('client.engraving.align_right')">
                        <button
                          class="operation__button"
                          :class="{'active': horizontalAlignmentRight}"
                          @click="setHorizontalAlignment('right')"
                        ><img src="/images/design/gravirovka/vyravnivanie-pravo.svg"></button>
                      </PopupTitle>

                    </div>
                  </div>
                  <div class="alignment__vertical">
                    <div class="operation__action">
                      <PopupTitle :titleText="$t('client.engraving.align_top')">
                        <button
                          class="operation__button"
                          :class="{'active': verticalAlignmentTop}"
                          @click="setVerticalAlignment('top')"
                        ><img src="/images/design/gravirovka/vyravnivanie-verh.svg"></button>
                      </PopupTitle>
                    </div>
                    <div class="operation__action">
                      <PopupTitle :titleText="$t('client.engraving.align_middle')">
                        <button
                          class="operation__button"
                          :class="{'active': verticalAlignmentMiddle}"
                          @click="setVerticalAlignment('middle')"
                        ><img src="/images/design/gravirovka/vyravnivanie-middle.svg"></button>
                      </PopupTitle>

                    </div>
                    <div class="operation__action">
                      <PopupTitle :titleText="$t('client.engraving.align_bottom')">
                        <button
                          class="operation__button"
                          :class="{'active': verticalAlignmentBottom}"
                          @click="setVerticalAlignment('bottom')"
                        ><img src="/images/design/gravirovka/vyravnivanie-niz.svg"></button>
                      </PopupTitle>
                    </div>
                  </div>

                </div>
              </div>

              <div class="operation delete">
                <div class="operation__title">{{$t('client.engraving.operation_delete')}}</div>
                <div class="operation__actions">
                  <div class="operation__action">
                    <PopupTitle :titleText="$t('client.engraving.remove')">
                      <button
                        class="operation__button"
                        @click="remove"
                      ><img src="/images/design/gravirovka/udalit.svg"></button>
                    </PopupTitle>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="panel__section"
          v-if="mainElementInfo"
        >
          <div class="panel__title">{{$t('client.engraving.surface')}}</div>
          <div class="panel__content">
            {{ Math.ceil(mainElementInfo.ySize*100) }} x {{ Math.ceil(mainElementInfo.xSize*100) }}
          </div>
        </div>
      </div>
      <div class="arrow">
        <button
          @click="showHidePanel"
          :class="{'open': show, 'active': item}"
        ><img
            src="/images/design/gravirovka/strelka-zakryt-parametry.svg"
            alt=""
          ></button>
      </div>

    </div>
  </div>

</template>
<script>
import { mapState } from "vuex";
import EditText from "../EngravingText/EditText.vue";
export default {
  name: "ElementEngravingSetting",
  components: { EditText },
  data() {
    return {
      editingText: null,
    };
  },
  mounted() {},
  computed: {
    ...mapState({
      item: (state) => state.ClientEngravingSettings.item,
      show: (state) => state.ClientEngravingSettings.show,
      mainElementInfo: (state) => state.ClientEngravingSettings.mainElementInfo,
    }),
    activeFace() {
      return this.$store.getters["clientOrder/activeFace"];
    },
    horizontalAlignmentLeft() {
      if (this.item.offsetLeft == 0) {
        return true;
      }
      return false;
    },
    horizontalAlignmentCenter() {
      if (this.item.offsetLeft == this.item.offsetCenterX) {
        return true;
      }
      return false;
    },
    horizontalAlignmentRight() {
      if (this.item.offsetLeft == this.item.offsetMaxX) {
        return true;
      }
      return false;
    },
    verticalAlignmentTop() {
      if (this.item.offsetTop == 0) {
        return true;
      }
      return false;
    },
    verticalAlignmentMiddle() {
      if (this.item.offsetTop == this.item.offsetCenterY) {
        return true;
      }
      return false;
    },
    verticalAlignmentBottom() {
      if (this.item.offsetTop == this.item.offsetMaxY) {
        return true;
      }
      return false;
    },
  },
  methods: {
    showHidePanel() {
      this.$store.dispatch("ClientEngravingSettings/setShow", !this.show);
    },
    mirror() {
      this.$store.dispatch("clientOrder/updateEngravingElement", {
        element_uuid: this.item.uuid,
        value: !this.item.mirrored,
        key: "mirrored",
      });

      this.$store.dispatch("ClientEngravingSettings/updateItem", {
        value: !this.item.mirrored,
        key: "mirrored",
      });
    },
    changeOffset(event, pos) {
      let offset = parseFloat(event.target.value);

      if (pos == "x") {
        this.$store.dispatch("clientOrder/updateEngravingElement", {
          element_uuid: this.item.uuid,
          value: offset,
          key: "offsetLeft",
        });
        this.$store.dispatch("ClientEngravingSettings/updateItem", {
          value: offset,
          key: "offsetLeft",
        });
      }

      if (pos == "y") {
        this.$store.dispatch("clientOrder/updateEngravingElement", {
          element_uuid: this.item.uuid,
          value: offset,
          key: "offsetTop",
        });
        this.$store.dispatch("ClientEngravingSettings/updateItem", {
          value: offset,
          key: "offsetTop",
        });
      }
    },
    changeAngle(event) {
      let angle = parseFloat(event.target.value);

      if (angle > 180) {
        angle = 180;
        this.$refs.elementAngle.value = angle;
      }
      if (angle < -180) {
        angle = -180;
        this.$refs.elementAngle.value = angle;
      }

      this.$store.dispatch("clientOrder/updateEngravingElement", {
        element_uuid: this.item.uuid,
        value: parseFloat(event.target.value),
        key: "angle",
      });

      this.$store.dispatch("ClientEngravingSettings/updateItem", {
        value: parseFloat(event.target.value),
        key: "angle",
      });
    },

    changeSize(event, param) {
      let val = parseFloat(event.target.value);

      if (this.item.proporcion) {
        let height = this.item.height;
        let width = this.item.width;
        if (param == "height") {
          height = val;
          width = (this.item.proporcionRatio * height).toFixed(1);
        }
        if (param == "width") {
          width = val;
          height = (width / this.item.proporcionRatio).toFixed(1);
        }
        this.$store.dispatch("clientOrder/updateEngravingElement", {
          element_uuid: this.item.uuid,
          value: height,
          key: "height",
        });
        this.$store.dispatch("clientOrder/updateEngravingElement", {
          element_uuid: this.item.uuid,
          value: width,
          key: "width",
        });

        this.$store.dispatch("ClientEngravingSettings/updateItem", {
          value: width,
          key: "width",
        });
        this.$store.dispatch("ClientEngravingSettings/updateItem", {
          value: height,
          key: "height",
        });
      } else {
        this.$store.dispatch("clientOrder/updateEngravingElement", {
          element_uuid: this.item.uuid,
          value: val,
          key: param,
        });
        this.$store.dispatch("ClientEngravingSettings/updateItem", {
          value: val,
          key: param,
        });
      }
    },

    selectSize(event) {
      const sizeId = event.target.value;
      const size = this.item.sizes.find((s) => s.element_size_id == sizeId);
      if (size) {
        this.$store.dispatch("clientOrder/updateEngravingElement", {
          element_uuid: this.item.uuid,
          value: size.height,
          key: "height",
        });

        this.$store.dispatch("ClientEngravingSettings/updateItem", {
          value: size.height,
          key: "height",
        });

        this.$store.dispatch("clientOrder/updateEngravingElement", {
          element_uuid: this.item.uuid,
          value: size.width,
          key: "width",
        });

        this.$store.dispatch("ClientEngravingSettings/updateItem", {
          value: size.width,
          key: "width",
        });

        this.$store.dispatch("clientOrder/updateEngravingElement", {
          element_uuid: this.item.uuid,
          value: sizeId,
          key: "sizeId",
        });

        this.$store.dispatch("ClientEngravingSettings/updateItem", {
          value: sizeId,
          key: "sizeId",
        });
        this.$store.dispatch("clientOrder/updateEngravingElement", {
          element_uuid: this.item.uuid,
          value: size,
          key: "size",
        });
        this.$store.dispatch("ClientEngravingSettings/updateItem", {
          value: size,
          key: "size",
        });
      }
    },

    setProporcion() {
      this.$store.dispatch("clientOrder/updateEngravingElement", {
        element_uuid: this.item.uuid,
        value: !this.item.proporcion,
        key: "proporcion",
      });
      this.$store.dispatch("ClientEngravingSettings/updateItem", {
        value: !this.item.proporcion,
        key: "proporcion",
      });
    },
    decrLayer() {
      this.$store.dispatch("clientOrder/updateEngravingElement", {
        element_uuid: this.item.uuid,
        value: this.item.layer - 0.00001,
        key: "layer",
      });
      this.$store.dispatch("ClientEngravingSettings/updateItem", {
        value: this.item.layer - 0.00001,
        key: "layer",
      });
    },
    incLayer() {
      this.$store.dispatch("clientOrder/updateEngravingElement", {
        element_uuid: this.item.uuid,
        value: this.item.layer + 0.00001,
        key: "layer",
      });
      this.$store.dispatch("ClientEngravingSettings/updateItem", {
        value: this.item.layer + 0.00001,
        key: "layer",
      });
    },
    setHorizontalAlignment(value) {
      if (value == "left") {
        this.$store.dispatch("clientOrder/updateEngravingElement", {
          element_uuid: this.item.uuid,
          value: 0,
          key: "offsetLeft",
        });
        this.$store.dispatch("ClientEngravingSettings/updateItem", {
          value: 0,
          key: "offsetLeft",
        });
      }
      if (value == "center") {
        this.$store.dispatch("clientOrder/updateEngravingElement", {
          element_uuid: this.item.uuid,
          value: this.item.offsetCenterX,
          key: "offsetLeft",
        });
        this.$store.dispatch("ClientEngravingSettings/updateItem", {
          value: this.item.offsetCenterX,
          key: "offsetLeft",
        });
      }
      if (value == "right") {
        this.$store.dispatch("clientOrder/updateEngravingElement", {
          element_uuid: this.item.uuid,
          value: this.item.offsetMaxX,
          key: "offsetLeft",
        });
        this.$store.dispatch("ClientEngravingSettings/updateItem", {
          value: this.item.offsetMaxX,
          key: "offsetLeft",
        });
      }
    },
    setVerticalAlignment(value) {
      if (value == "top") {
        this.$store.dispatch("clientOrder/updateEngravingElement", {
          element_uuid: this.item.uuid,
          value: 0,
          key: "offsetTop",
        });
        this.$store.dispatch("ClientEngravingSettings/updateItem", {
          value: 0,
          key: "offsetTop",
        });
      }
      if (value == "middle") {
        this.$store.dispatch("clientOrder/updateEngravingElement", {
          element_uuid: this.item.uuid,
          value: this.item.offsetCenterY,
          key: "offsetTop",
        });
        this.$store.dispatch("ClientEngravingSettings/updateItem", {
          value: this.item.offsetCenterY,
          key: "offsetTop",
        });
      }
      if (value == "bottom") {
        this.$store.dispatch("clientOrder/updateEngravingElement", {
          element_uuid: this.item.uuid,
          value: this.item.offsetMaxY,
          key: "offsetTop",
        });
        this.$store.dispatch("ClientEngravingSettings/updateItem", {
          value: this.item.offsetMaxY,
          key: "offsetTop",
        });
      }
    },
    async remove() {
      if (this.item.isText) {
        this.$store.dispatch("clientOrder/removeText", {
          face_id: this.activeFace.face_id,
          text_id: this.item.text_id,
        });
      } else {
        this.$store.dispatch("clientOrder/removeEngraving", {
          face_id: this.activeFace.face_id,
          element_uuid: this.item.uuid,
          uuid: this.item.uuid,
        });
      }

      this.$store.dispatch("ClientEngravingSettings/clear");
    },
  },
};
</script>
<style scoped>
.element-engraving-setting {
  display: flex;
  position: absolute;
  top: 50px;
  left: -97px;
  bottom: 0;
  z-index: 0;
  transition: all 0.2s;
}
.element-engraving-setting.open {
  left: 103px;
}
.arrow button {
  display: grid;
  place-content: center;
  width: 25px;
  height: 25px;
  background-color: #172935;
  border-radius: 0 0 5px 0;
}
.arrow button.active {
  background-color: #10b981;
}
.arrow button img {
  width: 10px;
  height: 15px;
  transform: rotateY(180deg);
}
.arrow button.open img {
  transform: rotateY(0deg);
}
.panel__form_group--proporcion {
  display: flex;
  align-items: flex-end;
  column-gap: 10px;
}

.panel {
  width: 215px;
  background-color: #e5e4e4;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  z-index: 2;
}
.panel__section {
  padding: 15px;
}
.panel__section + .panel__section {
  border-top: 1px solid #dad8d8;
}
.panel__form_group + .panel__form_group {
  margin-top: 10px;
}
.panel__title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 10px;
}
.panel__label {
  display: flex;
  align-items: center;
  column-gap: 5px;
  margin-bottom: 5px;
}
.panel__label span,
.operation__title {
  font-size: 12px;
}
.operation__title {
  margin-bottom: 5px;
}
.panel__field input,
.panel__field select {
  display: block;
  border: 1px solid #bbbbbb;
  height: 38px;
  display: block;
  text-align: center;
  display: block;
  width: 100%;
}
.panel__operations {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  row-gap: 15px;
}
.operation.operation--alignment {
  width: 100%;
}
.operation__actions {
  display: flex;
  column-gap: 10px;
}
.operation.operation--alignment .operation__actions {
  flex-direction: column;
  row-gap: 10px;
}

.operation .operation__action:hover {
  position: relative;
  z-index: 100;
}

.alignment__horizontal,
.alignment__vertical {
  display: flex;
  column-gap: 10px;
}

.operation.delete {
  color: #c31818;
}
.operation.delete button {
  width: 38px;
  height: 38px;
  border: 1px solid #c31818;
  display: grid;
  place-content: center;
}
.operation.delete button img {
  width: 20px;
  height: 23px;
}
.operation__button {
  width: 38px;
  height: 38px;
  display: grid;
  place-content: center;
  border: 1px solid #b1b1b1;
}
.operation__button:hover {
  background-color: #d1d1d1;
}

.operation__button:active {
  border-color: #10b981;
}

.operation__button img {
  width: 25px;
  height: 25px;
}
.operation__button.active {
  background-color: #10b981;
  border-color: #10b981;
}
.operation__button.operation__button--proporcion {
  width: 40px;
  height: 119px;
}

.btn-text-edit {
  color: #fff;
  background-color: #25a24c;
  display: flex;
  height: 40px;
  width: 100%;
  align-items: center;
  column-gap: 15px;
  padding-left: 10px;
  margin-bottom: 12px;
}
.btn-text-edit img {
  width: 24px;
  height: 24px;
}

@media screen and (max-width: 1000px) {
  .element-engraving-setting {
    top: 32px;
    left: -157px;
    bottom: 40px;
  }
  .element-engraving-setting.open {
    left: 50px;
  }
}
</style>

